import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface ManzanitaPresetListingFilters {
    sortBy: string;
    sortOrder: SortOrder;
    name?: string;
}

const defaultFilters: ManzanitaPresetListingFilters = {
    sortBy: "name",
    sortOrder: "asc",
    name: ""
};

export const useManzanitaPresetListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<ManzanitaPresetListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<ManzanitaPresetListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [location.pathname, history, filters]);

    const setSort = (sort: ListTableSort) => {
        setFilters((prevFilters: ManzanitaPresetListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order,
            page: 1
        }));
    };

    const setName = (name?: string): void => {
        setFilters((prevFilters: ManzanitaPresetListingFilters) => ({ ...prevFilters, name, page: 1 }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setName,
        setSort,
        clearFilters
    };
};
